<template>
  <div class="loading" v-if="fetchingPlans === true">
      <md-progress-spinner
        md-mode="indeterminate"
        :md-diameter="50"
        :md-stroke="3"
      ></md-progress-spinner>
    </div>
  <div v-else class="checkoutWrapper">
    <img src="@/assets/neou-logo.png" class="neouLogo" />
    <p class="plansIntro">Upgrade today and keep crushing it.</p>
    <h1 class="planHeader">Annual Plan</h1>
    <!-- <div class="plansDisplay">
      <div
          class="v-planWrapper"
          v-for="plan in offer"
          :key="plan.name"
          :class="getPlan(plan.id)[0].interval"
        >
        <md-radio class="md-primary radio" :value="plan.id" v-model="selectedPlan"><div v-html="plan.name"></div></md-radio>
      </div>
    </div> -->
    <div class="planInfo"
          v-for="plan in offer"
          :key="plan.name"
          :class="[getPlan(plan.id)[0].interval, {active: plan.id == selectedPlan}, {pulse: (lineItemCouponApplied && coupon.toUpperCase() =='HEART') || (lineItemCouponApplied && coupon.toUpperCase().indexOf('21') > -1) || lineItemCouponApplied && coupon.toUpperCase() =='NEOUS'|| lineItemCouponApplied && coupon.toUpperCase() =='IHEART' || lineItemCouponApplied && coupon.toUpperCase() =='BLACKFRIDAY'|| lineItemCouponApplied && coupon.toUpperCase() =='CYBERMONDAY'}]"
          @click="updateSelectedPlan(plan.id)">
        <div class="planLeft" v-if="(lineItemCouponApplied && coupon.toUpperCase() =='BLACKFRIDAY'|| lineItemCouponApplied && coupon.toUpperCase() =='CYBERMONDAY') && getPlan(plan.id)[0].trial_period_days == 365">
          <div class="priceWrapper">
            <p class="price">${{getPlan(plan.id)[0].amount}}<span class="period">/<span class="interval" v-if="getPlan(plan.id)[0].interval_count > 1">{{getPlan(plan.id)[0].interval_count}}</span> {{getPlan(plan.id)[0].interval}}</span></p>>
          </div>
          <p class="fine">Your membership will auto-renew at $24.99 billed annually. Cancel any time.</p>
        </div>
        <div class="planLeft" v-else>
          <div class="priceWrapper">
            <p class="price">${{getPlan(plan.id)[0].amount}}<span class="period">/<span class="interval" v-if="getPlan(plan.id)[0].interval_count > 1">{{getPlan(plan.id)[0].interval_count}}</span> {{getPlan(plan.id)[0].interval}}</span></p>
            <p class="perk">40% OFF</p>
          </div>
          <p class="fine" v-if="getPlan(plan.id)[0].trial_period_days > 0">Your membership will auto-renew at $24.99 billed annually. Cancel any time.</p>
          <p class="fine" v-else>Your membership will auto-renew at $24.99 billed annually. Cancel any time.</p>
        </div>
    </div>    
    <div class="buttonWrapper">
      <button
        class="pay-with-stripe"
        @click="pay"
        :disabled="submitting"
      >
        <span v-if="getPlan(this.selectedPlan)[0].trial_period_days > 0"
          >Upgrade Now</span
        >
        <span v-else>Upgrade Now</span>
      </button>
    </div>
    <div v-if="formError !== false" class="formError">{{ formError }}</div>
  </div>
</template>

<script>
import Vue from "vue";
import { MdField, MdRadio } from "vue-material/dist/components";
import axios from "axios";
import { Card, createPaymentMethod } from "vue-stripe-elements-plus";
import { parse } from "query-string";
import browserDetect from "vue-browser-detect-plugin";

Vue.use(browserDetect);
Vue.use(MdField);
Vue.use(MdRadio);

export default {
  name: "LightCheckout",
  data: () => ({
    submitting: false,
    name: null,
    complete: false,
    formError: false,
    didTogglePlans: false,
    allowedCodes:[
      "WELLY",
      "HEART",
      "NEOUS",
      "IHEART",
      "BLACKFRIDAY",
      "CYBERMONDAY",
      "ANDREA21",
      "ANDREW21",
      "AMANDA21",
      "BLAKE21",
      "BOBH21",
      "BRIANNA21",
      "BRITNEY21",
      "CHRISTI21",
      "CAMERON21",
      "DANI21",
      "EBONNY21",
      "ELISSA21",
      "FORME21",
      "IVY21",
      "JOSEPH21",
      "KICKIT21",
      "SARAH21",
      "STAN21",
      "SYDNI21",
      "TARA21",
    ],
    couponLookup:{
      "ANDREA21": "brand_adffitness_brand",
      "ANDREW21": "brand_limitless",
      "AMANDA21": "brand_adp_amanda",
      "BLAKE21": "brand_base",
      "BOBH21": "brand_bob_harper",
      "BRIANNA21": "brand_bodybybree",
      "BRITNEY21": "brand_move_britneybyfield",
      "CHRISTI21": "brand_go_christi",
      "CAMERON21": "brand_cardioburn_cameron",
      "DANI21": "brand_shred_daniirwin",
      "EBONNY21": "brand_funwithfit",
      "ELISSA21": "brand_gesticulate",
      "FORME21": "brand_formebarre",
      "IVY21": "brand_fullout_ivy",
      "JOSEPH21": "brand_push_josephd",
      "KICKIT21": "brand_kickitbyeliza",
      "SARAH21": "brand_sarahotey",
      "SYDNEY21": "brand_fullout_sydni",
      "STAN21": "brand_onefit",
      "TARA21": "brand_empwr",
    },
    lineItemCouponApplied: false,
    lineItemCouponError: false,
    coupon: "",
    shopCode: "",
    stripeOptions: {
      elements:{
        fonts:[{
            family: 'prox',
            src: 'url(https://get.neoufitness.com/fonts/proximanova-regular-webfont.woff)',
            weight:'400'
          }
        ]
      },
      style: {
        base: {
          iconColor: "#35414A",
          color: "#8b949b",
          fontSize: "16px",
          fontFamily: '"prox", Helvetica',
          color:"#12161A",
          '::placeholder':{
            color:'#8B949B'
          }
        }
      }
    },
    params: {},
    offer: window.planOffers.plans,
    fetchingPlans: true,
    plans: {},
    selectedPlan: window.planOffers.plans[0].id
  }),
  beforeMount: function() {
    if( window.localStorage.getItem( 'neouPlans' ) == null ) {
      axios
        .get(
          "https://api.neoufitness.com/neou/v1/subscription/plan?isMarketing=true",
          {
            headers: {
              Authorization: "JWT " + this.$cookie.get("token"),
              token: this.$cookie.get("getUserToken")
            }
          }
        )
        .then(res => {
          console.log(res.data.result.products);
          this.plans = res.data.result.products;
          // Track View Plans
          window.analytics.track("View Plans", {
            products_displayed: this.offer.map(plan => plan.id)
          });
          this.fetchingPlans = false;
        })
        .catch(err => {
          console.log(err);
        });
      } else {
        console.log( 'got stored plans' );
        this.plans = JSON.parse(window.localStorage.getItem( 'neouPlans' ));
        // Track View Plans
        window.analytics.track("View Plans", {
          products_displayed: this.offer.map(plan => plan.id)
        });
        this.fetchingPlans = false;
      }
    window.dataLayer.push({
      event: "view_plans",
      products_displayed: "Annual"
    });
    window.dataLayer.push({
      event: "cap_one_view_plans",
    });
    this.params = parse(window.location.search);
    // Auto-apply coupon
    if( "neouCoupon" in window ){
      this.lineItemCouponApplied = true;
      this.coupon = window.neouCoupon;
      this.applyCoupon();
    }
  },
  components: { Card },
  watch: {
    selectedPlan: function(){
      if ( !this.didTogglePlans ) {
        window.dataLayer.push({
          event: "view_plans",
          products_displayed: "Month"
        });
        this.didTogglePlans = true;
      }
    }
  },
  methods: {
    updateSelectedPlan(planId){
      this.selectedPlan = planId
    },
    applyCoupon(){
      this.lineItemCouponError = false;
      if( this.allowedCodes.indexOf( this.coupon.toUpperCase() ) > -1 ) {
        this.lineItemCouponApplied = true;
        if (this.coupon.toUpperCase() == "HEART") {
          this.oldPlan = this.offer[0].id;
          this.offer[0].id = "price_1JPBtdDej2Rk1s0Kn1p47jQ0";
          this.selectedPlan = "price_1JPBtdDej2Rk1s0Kn1p47jQ0";
        }
        if( this.coupon.toUpperCase() == "IHEART" ) {
          // Brand Coupons
          this.oldPlan = this.offer[0].id;
          this.oldMonthlyPlan = this.offer[1].id;
          // Set annaul plan
          this.offer[0].id = "price_1JfUFEDej2Rk1s0KXofEjggk";
          this.offer[1].id = "price_1JfUFxDej2Rk1s0KlPMQNG4C";
          this.selectedPlan = "price_1JfUFEDej2Rk1s0KXofEjggk";
        }
        if( this.coupon.toUpperCase().indexOf("21") > -1 ) {
          // Brand Coupons
          this.oldPlan = this.offer[0].id;
          this.oldMonthlyPlan = this.offer[1].id;
          // Set annaul plan
          this.offer[0].id = "price_1JXS20Dej2Rk1s0KFCfciXom";
          this.offer[1].id = "price_1JXS2xDej2Rk1s0KMDtiPBLN";
          this.selectedPlan = "price_1JXS20Dej2Rk1s0KFCfciXom";
        }
        if( this.coupon.toUpperCase() == "NEOUS" ){
          this.oldPlan = this.offer[0].id;
          this.offer[0].id = "price_1JXS20Dej2Rk1s0KFCfciXom";
          this.selectedPlan = "price_1JXS20Dej2Rk1s0KFCfciXom";
        }
        if (this.coupon.toUpperCase() == "BLACKFRIDAY" || this.coupon.toUpperCase() == "CYBERMONDAY") {
          this.oldPlan = this.offer[0].id;
          this.offer[0].id = "price_1JxbtFDej2Rk1s0KhrWCwH1u";
          this.selectedPlan = "price_1JxbtFDej2Rk1s0KhrWCwH1u";
        }
      } else {
        this.lineItemCouponError = "Coupon code invalid"
      }
    },
    removeCoupon(){
      this.lineItemCouponApplied = false;
      this.coupon = "";
      if ( this.oldPlan ) {
        this.offer[0].id = this.oldPlan;
        this.selectedPlan = this.oldPlan;
      }
      if ( this.oldMonthlyPlan ) {
        this.offer[1].id = this.oldMonthlyPlan;
      }
    },
    abbreviate( string ){
      if (string == "month" ) {
        return "mo";
      } else {
        return string;
      }
    },
    formModified() {
      window.analytics.track("Checkout Started");
      window.dataLayer.push({
        event: "checkout_started"
      });
    },
    test() {
      console.log( this.getPlan(this.selectedPlan) );
    },
    pay() {
      window.analytics.track("Plan Upgrade Click");
      if(this.$attrs.paymentId == ''){
        this.submitting = true;
        this.$emit(
          "warningMessage",
          "There was an error fetching your account details please reach out to info@neoufitness.com for assistance"
        );
        return;
      }
      this.handlePlanSelected(this.getPlan(this.selectedPlan), this.getPlan(this.selectedPlan)[0].name);
      this.submitting = true;
        axios
          .post(
            "https://api.neoufitness.com/neou/v1/user/upgrade",
            {
              new_plan: this.selectedPlan,
              payment: this.$attrs.paymentId
            },
            {
              headers: {
                Authorization: "JWT " + this.$cookie.get("token"),
                token: this.$cookie.get("getUserToken")
              }
            }
          )
          .then(res => {
            window.analytics.track("Plan Upgrade Complete");
            window.dataLayer.push({
              event: "plan_upgrade_complete"
            });
            // Get the user info and send an updated subscription status
            axios
              .get("https://api.neoufitness.com/neou/v1/user/", {
                headers: {
                  Authorization: "JWT " + this.$cookie.get("token"),
                  token: this.$cookie.get("getUserToken")
                }
              })
              .then(res => {
                console.log( res );
                let attrs = {
                  subscription_end_date: res.data.result.subscription.expiryDate,
                  subscription_plan: res.data.result.subscription.productId,
                  subscription_status: "active",
                  subscription_start_date: new Date().toISOString(),
                  subscription_platform: "web_browser",
                  subscription_price_id: this.$attrs.selectedPlan.id,
                  upgraded_from_monthly: true
                }
                window.analytics.identify(res.id, attrs);
              });
            this.$emit("nextScreen");
          })
          .catch(err => {
            if( err.response.status == 403 ) {
              console.error("403");
              console.error(err.response.data.error)
              console.error(err.response.data.message)
              this.$emit("nextScreen");
            } else {
              this.$emit(
              "warningMessage",
                "Unknown error"
              );
              console.error("Unknown Error");
              console.error(err.response.data.error)
              console.error(err.response.data.message)
            }
          });
    },
    handlePlanSelected: function(selectedPlan, title) {
      // if (selectedPlan.length == 1) {
      //   selectedPlan = selectedPlan[0];
      // }
      selectedPlan[0]["name"] = title;
      this.$emit("selectedPlan", selectedPlan[0]);
      window.dataLayer.push({
        event: "select_plan",
        plan_id: selectedPlan[0].id
      });
      // Track Plan Selected
      window.analytics.track("Select Plan", {
        products_displayed: this.offer.map(plan => plan.id),
        selected_product: selectedPlan[0].id
      });
      // Annual or Monthly
      if (selectedPlan[0].trial_period_days > 0) {
        window.analytics.track("Select Plan Trial");
        window.dataLayer.push({
          event: "select_plan_trial"
        });
      } else {
        window.analytics.track("Select Plan Monthly");
        window.dataLayer.push({
          event: "select_plan_monthly"
        });
      }
    },
    getCurrency: function(currency) {
      if (currency == "usd") {
        return "$";
      }
      if (currency == "gbp") {
        return "Â£";
      }
      if (currency == "cad") {
        return "$";
      }
      if (currency == "aud") {
        return "$";
      }
    },
    getBilling: function(interval) {
      if (interval == "year") {
        return "billed annually";
      }
      if (interval == "month") {
        return "billed monthly";
      }
    },
    clearError: function() {
      this.formError = false;
    },
    getPlan: function(planToFind) {
      let prices = [];
      this.plans.forEach(plan => {
        prices.push(...plan.plans);
      });
      return prices.filter(price => {
        return price.id == planToFind;
      });
    }
  }
};
</script>
<style lang="scss">
.radio{
  .md-radio-container{
    border-color:#000000 !important;
    width: 15px;
    min-width: 15px;
    height: 15px;
  }

  label{
    font-size:11px;
    font-weight:600;
    padding-left:6px;
  }
}

.md-radio{
  margin-right:0px;
  .md-radio-label{
    padding-left:3px;
  }
}

.md-radio{
  &.md-checked{
    .md-radio-container{
      &:after{
        background-color:#000000;
      }
    }
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.neouLogo {
  width: 160px;
  margin: 0px auto;
  display: block;
  filter:invert(1);
}
.plansIntro{
  margin-top:10px;
  margin-bottom:20px;
  color:#505B63;
  text-align:center;
}
.md-progress-spinner {
  stroke: black;
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  display: inline-flex;
}
.planHeader{
  color:#000000;
  font-size:13px;
  margin:0px 0px 15px 0px;
  text-align:center;
  font-weight:600;
  letter-spacing:0.54px;
  text-transform:uppercase;
}
.plansDisplay{
  color:#000000;
  display:flex;
  margin-bottom:15px;
  justify-content:space-around;
}
.couponItem{
  border:1px solid #CDD3D8;
  padding:10px 20px;
  color:#12161A;
  font-size:12px;
  margin-top:20px;
}
.couponHint{
  color:#8B949B;
  margin:0px;
}
.couponCode{
  margin:0px;
  font-size:14px;
  color:#1c2024;
  font-weight:500;
}
.couponInfo{
  line-height:14px;
  font-style:italic;
  margin-bottom:0px;
  margin-top:10px;
  color:#293138;

  a{
    color:#293138;
    text-decoration:underline;
  }
}
.removeButton{
  float:right;
  background-color:#35414a;
  border-radius:6px;
  color:#ffffff;
  text-transform:none;
  font-weight:400;
  font-size:12px;
  height:30px;
  min-width:68px;
  margin-top:-5px;
}
.couponField{
  text-transform:uppercase;
}
.couponError{
  color:red;
}
.planInfo{
  border:1px solid #CDD3D8;
  border-radius:6px;
}
.planInfo{
  text-align:center;
  cursor:pointer;
  display:flex;
  justify-content:space-between;
  padding:15px 20px 20px 20px;
  margin-bottom:15px;

  .price{
    color:#12161A;
    font-size:30px;
    font-weight:400;
    line-height:23px;
    vertical-align:top;
    margin:0px 0px 10px 0px;
  }
  .period{
    font-size:18px;
    display:inline-block;
    margin-left:5px;
  }
  .details{
    font-size:12px;
    line-height:16px;
    color:#222A31;
    margin:0px;
  }
  .red{
    color:#FF1C58;
    font-weight:500;
    text-transform:uppercase;
  }
  .boldCopy{
    font-weight:600;
    margin:4px 0px;
    font-size:10px;
  }
  .originalAmount{
    text-decoration:line-through;
  }
  .rate{
    font-style:italic;
  }
  .subtitle{
    background-color:#F3F3F3;
    color:#12161A;
    text-transform:uppercase;
    font-weight:600;
    font-size:12px;
    line-height:14px;
    display:block;
    text-align:center;
    padding:6px 0px;
    margin:0px;
  }
  &.year{
    .subtitle{
      background-color:rgba(255,229,68,0.35);
    }
  }
  .fine{
    color:#505B63;
    font-size:11px;
    line-height:16px;
    text-align:left;
    margin:0px;
  }
  &.active{
    border:3px solid #2ADCFE;
    
    .planLeft{
      margin:-2px;
    }

  }
}
.formHeader{
  text-transform:uppercase;
  font-weight:600;
  color:#000000;
  text-align:center;
  font-size:13px;
  margin-top:20px;
}
.md-field label {
  color: #8B949B;
  font-style: initial;
}
.poweredBy{
  margin-top:30px;
  color:#8B949B;
  font-size:10px;
  text-align:center;
}
.poweredByImage{
  display:inline-block;
  height:20px;
  opacity:0.6
}
.paymentWrapper {
  text-align: center;
  padding: 16px;
  position: relative;
  border: 1px solid #35414a;
}
.paymentReqBtnWrap {
  top: -8px;
  position: absolute;
  justify-content: center;
  display: flex;
  color: white;
  width: 100%;
  left: 0;
}
.expressCheckout {
  color: #8b949b;
  font-family: "prox", Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  background: #080b0d;
  padding: 0px 22px;
}
.gPay {
  background: white;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gPayImg {
  width: auto;
  background: white;
  height: 20px;
  z-index: 1;
  left: 0;
}
.orLine {
  overflow: hidden;
  padding: 0px;
  text-align: center;
  color: #35414a;
  line-height: 40px;
  width: 100%;
  &:before,
  &:after {
    background-color: #35414a;
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 40%;
    color: #35414a;
  }
  &:before {
    right: 0.5em;
    margin-left: -25%;
  }
  &:after {
    left: 0.5em;
    margin-right: -25%;
  }
  span {
    font-size: 12px;
    line-height: 40px;
    text-align: center;
    padding: 20px;
    color: #8c949b;
    font-weight: bold;
  }
}
.checkoutBox {
  margin: 0px;
}
.checkoutWrapper {
  color: #ffffff;
  max-width: 400px;
  width: 100%;
  margin: 0px auto;
  padding: 40px 15px 40px;
}
.buttonWrapper {
  padding: 20px 0px 0px;
  margin: 20px 0px 0px 0px;
  position: relative;
  z-index: 2;
}
.pay-with-stripe {
  width: 100%;
  border: none;
  cursor: pointer;
  height: 40px;
  outline: none;
  line-height: 40px;
  font-size: 13px;
  background: linear-gradient(45deg, #22d6fe, #51fbfe);
  margin: 0px auto 0px auto;
  font-family: "prox", Helvetica, Arial, sans-serif;
  line-height: 20px;
  border-color: black;
  border-radius: 6px;
  letter-spacing: 1px;
  text-transform: uppercase;
  box-sizing: border-box;
  font-weight: bold;
  display: block;
  position: relative;
  z-index: 2;
}
.md-field:after {
  border-bottom: 1px solid #35414a;
}
.stripe-card {
  padding-bottom: 5px;
  border-bottom: 1px solid #35414a;
}

.md-field .md-input {
  color: #12161A;
}
.priceWrapper{
  display:flex;
  justify-content: space-between;
  align-items:flex-end;
}
.perk{
  background-color:#12161A;
  padding:2px 6px;
  text-transform:uppercase;
  font-weight:bold;
  font-size:12px;
}
.inlineCouponInfo{
  font-size: 11px;
  line-height: 14px;
  text-align: left;
  margin: -18px 0px 0px 0px;
  color: rgb(140, 148, 155);
}
@media screen and ( min-width: 500px ) {
  h2 {
    text-align: center;
  }
  .formError {
    color: #ff1c58;
    text-align: center;
    font-size: 12px;
    font-style: italic;
    margin-top: 10px;
  }
  .upper {
    text-transform: uppercase;
  }
  .currency,
  .dollars,
  .dot {
    float: left;
  }
}
@media screen and (min-width: 550px) {
  .buttonWrapper {
    background: none;

    &::before {
      display: none;
    }
  }
  .radio{
    label{
      font-size:15px;
    }
  }

  .md-radio{
    margin-right:16px;
  }

  .planInfo{
    .price{
      text-align:left;
    }
    .details{
      text-align:left;
    }
  }
}

@media screen and (max-width:380px) {
  .planInfo{
    padding:10px;
    .price{
      font-size:28px;
    }

    .perk{
      font-size:11px;
    }

    .period{
      font-size:14px;
    }
  }
}

.planInfo{
  box-shadow: 0 0 0 0 rgba(42,220,254, 1);
  transform: scale(1);

  &.pulse{
    &.active{
      &.year{
        animation: pulse 1.25s;        
      }
    }
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(42,220,254, 0.7);
    background:rgba(42, 219, 254, 0.1);
  }

  20%{
    transform:scale(0.95);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(42,220,254, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(42,220,254, 0);
  }
}
</style>